module.exports = __webpack_public_path__ + "img/tefal.c81f0368.jpg";